import withStartUpApp from '@/bootstarp/startup';
import Layout from '@/components/layout/Layout.vue';
import createRouter from '@/router';

withStartUpApp(Layout, {
  preloadImages: ['/course/banner.png'],
  beforeMount(app) {
    createRouter(app, [
      {
        path: '/',
        component: () => import('@/pages/course/CourseIndex.vue'),
      },
    ]);
  },
});
